module.exports = __webpack_public_path__ + "static/media/favicon.ceec94f4.png";